import React from 'react';

/**
 * Simple three-step flow — how the product works in practice.
 * Avoids About-style pillars / mission statements.
 */
function HowItWorksSection() {
  const steps = [
    {
      num: '01',
      title: 'Show up with a clear profile',
      body: 'Share skills, intent, and what you are building or seeking so the right people can find you.',
    },
    {
      num: '02',
      title: 'Discover and start conversations',
      body: 'Search co-founders and talent, browse roles, or join the feed — then reach out with context.',
    },
    {
      num: '03',
      title: 'Move from match to momentum',
      body: 'Hire, partner, or raise interest with tools that keep the startup ecosystem in one place.',
    },
  ];

  return (
    <section className="home-how" id="how-it-works">
      <div className="home-section-inner">
        <header className="home-section-head ch-reveal">
          <h2>How CofounderHubs works</h2>
          <p>Three moves from landing here to building with someone new.</p>
        </header>
        <ol className="home-how-list">
          {steps.map((step, index) => (
            <li key={step.num} className={`home-how-step ch-reveal ch-reveal-delay-${index + 1}`}>
              <span className="home-how-num" aria-hidden="true">
                {step.num}
              </span>
              <div>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default HowItWorksSection;
